{
  "fr": {
    "upload": {
      "labels": {
        "cancelUpload": "Annuler le téléchargement",
        "cancelUploadConfirmation": "Êtes-vous sûr de vouloir annuler ce téléchargement ?",
        "chooseCategory": "Cliquez pour sélectionner d'abord une catégorie",
        "defaultMessage": "Ajouter ou déposer des fichiers",
        "fallbackMessage": "Votre navigateur ne prend pas en charge les téléchargements de fichiers par glisser-déposer.",
        "fallbackText": "Veuillez utiliser le formulaire de secours ci-dessous pour télécharger vos fichiers comme au bon vieux temps.",
        "fileTooBig": "Le fichier est trop volumineux ({filesize} MB). Taille max. des fichiers : {maxFilesize} MB.",
        "invalidFileType": "Vous ne pouvez pas télécharger de fichiers de ce type.",
        "maxFilesExceeded": "Vous ne pouvez plus télécharger de fichiers.",
        "noExtension": "Le fichier n'a pas d'extension",
        "rejectedFiles": "Les fichiers suivants ont été rejetés :",
        "removeFile": "Supprimer le fichier",
        "responseError": "Le serveur a répondu par le code {statusCode}.",
        "uploadConfirmation": "Téléchargement confirmé",
        "uploadError": "Erreur de téléchargement",
        "warningMaxFileSize": "Jusqu'à {max_files_size} chacun"
      }
    }
  }
}